const verge = require('verge');

$.fn.randomLines = function (options) {
	var viewportwidth = this.width(),
		viewportHeight = this.height(),
		elID = this.attr('id'),
		interval = null,
		orientation = 'vertical',
		settings = $.extend({
			svgId: null,
			strokeColor: '#000',
			strokeWidth: 2,
			animateTime: 1000,
			interval: 600,
			fadeOutTime: 800,
			lifeTime: 2000,
			width: viewportwidth,
			height: viewportHeight,
			leftRight: true,
			easing: 'swing',
			animationTimeRange: null
		}, options);
	$.fn.randomLines.destroy = function () {
		if (interval) {
			clearInterval(interval);
		}
	};
	function createLine(width, height, orientation) {
		var el = document.getElementById(elID),
			width = el.clientWidth,
			height = el.clientHeight;

		var startItemsWidth = new Array(0, width),
			ramdomItemWidth = startItemsWidth[Math.floor(Math.random() * startItemsWidth.length)],
			startItemsHeight = new Array(0, height),
			ramdomItemHeight = startItemsHeight[Math.floor(Math.random() * startItemsHeight.length)];
		var svgns = 'http://www.w3.org/2000/svg';
		var x1 = ramdomItemWidth,
			y1 = Math.random() * height,
			x2,
			y2 = Math.random() * height;

		if (orientation == 'vertical') {
			x1 = ramdomItemWidth;
			if (ramdomItemWidth === 0) {
				x2 = width;
			} else {
				x2 = 0;
			}
		} else if (orientation == 'horizontal') {
			var range1 = Math.floor(Math.random() * width) + 0;
			var range2 = Math.floor(Math.random() * width) + 0;
			x1 = range1;
			x2 = range2;
			y1 = ramdomItemHeight;
			if (ramdomItemHeight === 0) {
				y2 = height;
			} else {
				y2 = 0;
			}
		}
		var line = document.createElementNS(svgns, 'path');
		line.setAttributeNS(null, 'd', 'M ' + x1 + ' ' + y1 + ' L ' + x2 + ' ' + y2);
		line.setAttributeNS(null, 'stroke-width', settings.strokeWidth);
		line.setAttributeNS(null, 'stroke', settings.strokeColor);
		line.setAttributeNS(null, 'class', 'line off');
		if (settings.svgId) {
			document.getElementById(settings.svgId).appendChild(line);
		} else {
			document.getElementById(elID).appendChild(line);
		}
		var length = line.getTotalLength();
		line.setAttributeNS(null, 'stroke-dasharray', length);
		line.setAttributeNS(null, 'stroke-dashoffset', length);
	}

	function animate() {
		var time = settings.animationTime;
		if (settings.animationTimeRange) {
			time = Math.floor(Math.random() * (settings.animationTimeRange[1] - settings.animationTimeRange[0] + 1) + settings.animationTimeRange[0]);
		}
		$('.line.off').each(function () {
			$(this)
				.velocity({
					strokeDashoffset: 0
				}, {
					duration: time,
					easing: settings.easing,
					begin: function () {
						$(this)
							.addClass('on')
							.removeClass('off');
					},
					complete: function () {
						$(this)
							.velocity('fadeOut', {
								delay: settings.lifeTime - time,
								duration: settings.fadeOutTime,
								complete: function () {
									$(this).remove();
								}
							});
					}
				});
		});
	}

	interval = setInterval(function () {
		if (orientation == 'vertical') {
			orientation = 'horizontal';
		} else if (orientation == 'horizontal') {
			orientation = 'vertical';
		}

		if (verge.viewportW() > 768) {
			createLine(settings.width, settings.height, orientation);
			animate();
		}
	}, settings.interval);
};


if (verge.viewportW() > 768) {
	if ($('#swiper-main-random-lines').length) {
		$('#swiper-main-random-lines').randomLines({
			strokeColor: 'rgba(255,255,255,0.1)',
			interval: 1750,
			animateTime: 4000,
			lifeTime: 6000,
			animationTimeRange: [3000, 5000]
		});
	}

	if ($('#main-contacts-random-lines').length) {
		$('#main-contacts-random-lines').randomLines({
			strokeColor: 'rgba(255,255,255,0.1)',
			interval: 1750,
			animateTime: 4000,
			lifeTime: 6000,
			animationTimeRange: [3000, 5000]
		});
	}

	if ($('#header-work-random-lines').length) {
		$('#header-work-random-lines').randomLines({
			strokeColor: 'rgba(255,255,255,0.1)',
			interval: 1750,
			animateTime: 4000,
			lifeTime: 6000,
			animationTimeRange: [3000, 5000]
		});
	}
}

$(window).on('resize', function() {
	if (verge.viewportW() > 768) {
		if ($('#swiper-main-random-lines').length && $('#swiper-main-random-lines').find('path').length) {
			$('#swiper-main-random-lines').randomLines.destroy();
		}
		if ($('#main-contacts-random-lines').length && $('#main-contacts-random-lines').find('path').length) {
			$('#main-contacts-random-lines').randomLines.destroy();
		}
		if ($('#header-work-random-lines').length && $('#header-work-random-lines').find('path').length) {
			$('#header-work-random-lines').randomLines.destroy();
		}
	}
});



// WEBPACK FOOTER //
// ./frontend/components/random-lines/random-lines.js